import { RECENT_ACTIVITY } from "../constants/userConstants";

export const getAllActivity = (data) => {
  return { type: RECENT_ACTIVITY.GET_ALL_ACTIVITY, payload: data };
};

export const addNewActivity = (data) => {
  return { type: RECENT_ACTIVITY.ADD_NEW_ACTIVITY, payload: data };
};
